module.exports = __webpack_public_path__ + "2ab4b707385b4ec968a96c3c1f242f3c.woff";